import {ManifestAttributeFilter} from "../../../../../../generated/graphql";
import {ManifestFilterType} from "../ManifestFilterState";
import {AbstractManifestViewFilter} from "./AbstractManifestViewFilter";

export class DriverGroupManifestFilter extends AbstractManifestViewFilter<number> {
  constructor() {
    super(ManifestFilterType.DRIVER_GROUP);
  }

  toFilter(): ManifestAttributeFilter | undefined {
    if (this.value.size > 0) {
      const filterItems: ManifestAttributeFilter[] = Array.from(this.value).map((value) => {
        return {
          dispatchGroup_dispatchGroupId: {eq: value}
        } as ManifestAttributeFilter;
      });
      return this.handleMultiValuedFilter(filterItems);
    }
    return undefined;
  }
}
